import { render, staticRenderFns } from "./PatientCardTest.vue?vue&type=template&id=59504cd2&scoped=true"
import script from "./PatientCardTest.vue?vue&type=script&lang=js"
export * from "./PatientCardTest.vue?vue&type=script&lang=js"
import style0 from "./PatientCardTest.vue?vue&type=style&index=0&id=59504cd2&prod&scoped=true&lang=css"
import style1 from "./PatientCardTest.vue?vue&type=style&index=1&id=59504cd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59504cd2",
  null
  
)

export default component.exports